/**
 * Z-Index utility for consistent layering across the application
 * 
 * Usage:
 * - Use these constants instead of hardcoded values
 * - Bottom navigation should always be below modals
 * - Full-screen modals should be above bottom navigation
 * - Toast notifications should be at the top
 */

export const Z_INDEX = {
  // Base levels
  BASE: 0,
  DROPDOWN: 10,
  STICKY: 20,
  TOOLTIP: 30,
  
  // Navigation
  BOTTOM_NAVIGATION: 50,
  
  // Modals and overlays
  MODAL_BACKDROP: 60,
  MODAL_CONTENT: 61,
  BOTTOM_SHEET: 60, // Same as modal backdrop for bottom-sliding modals
  
  // High priority modals
  PREFERENCES_MODAL: 100,
  FULL_SCREEN_MODAL: 100,
  
  // Notifications and toasts (highest priority)
  TOAST: 1000,
  NOTIFICATION: 1000,
} as const;

export type ZIndexLevel = typeof Z_INDEX[keyof typeof Z_INDEX];

/**
 * Get z-index class for Tailwind CSS
 */
export const getZIndexClass = (level: ZIndexLevel): string => {
  if (level <= 50) {
    return `z-${level}`;
  }
  return `z-[${level}]`;
}; 